export default __webpack_public_path__ + "static/media/vk_ico.2dd25bdd.svg";